module.exports = __webpack_public_path__ + "media/components/Application/Influencers/Index/InfluencerExample/3_icon-2a94e354f4d93c4df5bd26680d9dbd68.png";